<div attr.aria-describedby="{{ id }}-help">
  <div
    *ngIf="header_text"
    class="header-text normalize-external-styles"
    [innerHTML]="header_text | domSanitizer"
  ></div>

  <tds-type-ahead
    [id]="id"
    [label]="label"
    [placeholder]="'person_select_placeholder' | translate"
    [control]="control"
    [typeahead]="search"
    [loading]="loading"
    [item_not_found]="no_results_found"
    [result_format]="input_format"
    [input_format]="input_format"
    [editable]="false"
    [help_text]="help_text"
    [input_required_translation]="'input_is_required' | translate : label"
    [no_results_found_translation]="'no_results_found' | translate"
    [loading_translation]="'loading' | translate"
  />
</div>
